import { render, staticRenderFns } from "./BInput.vue?vue&type=template&id=6f35b202&scoped=true"
import script from "./BInput.vue?vue&type=script&lang=js"
export * from "./BInput.vue?vue&type=script&lang=js"
import style0 from "./BInput.vue?vue&type=style&index=0&id=6f35b202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f35b202",
  null
  
)

export default component.exports